import { ISetModuleKeyValueActionPayload } from '../interfaces/set-module-property.action-payload.interface';

export class SetModuleKeyValue {
    static readonly type = '[Module] SetModuleKeyValue';

    constructor(public payload: ISetModuleKeyValueActionPayload) {}
}
